// MUI
import { Divider } from "@mui/material";

// Components
import AllowableDistance from "@Settings/components/AdministrationTools/GlobalPositioningService/sections/AllowableDistance";

// Types
import { TSelectValue } from "@Layouts/components/InputComponents/SmartSelector/interfaces";
import { GPSSelectedProvider } from "@Settings/types/administrationTools/utils";

type ConfigurationSetsProps = Readonly<{
	isLoading: boolean;
	selectedProvider: GPSSelectedProvider;
	// Callbacks
	onUpdateAllowableDistance: (value: string | TSelectValue, prop: "distance" | "unit", providerDBProperty: string) => void;
}>;
export default function ConfigurationSets(props: ConfigurationSetsProps) {
	const { isLoading, selectedProvider } = props;
	const { allowableDistance, providerDBProperty } = selectedProvider;

	if (providerDBProperty === "lojack") {
		return (
			<>
				<Divider sx={{ borderWidth: "1px" }} variant="fullWidth" className={"!mt-8 !mb-6 !w-[97.5%]"} />
				<AllowableDistance
					allowableDistance={allowableDistance}
					isLoading={isLoading}
					providerDBProperty={providerDBProperty}
					// Callbacks
					onActionUpdate={props.onUpdateAllowableDistance}
				/>
			</>
		);
	}

	return null;
}
